import React from 'react';
function PdpCtaSkeleton() {
  return <div className='fixed bottom-0 right-0 z-[99999999] grid h-[76px] w-full grid-cols-2 items-center justify-items-center rounded border-t border-border-gray-light bg-surface-solid-0 px-4 py-3 lg:hidden' data-sentry-component="PdpCtaSkeleton" data-sentry-source-file="pdp-cta-skeleton.tsx">
            <div className='h-11 w-full animate-pulse rounded bg-gray-100' />
            <div className='h-6 w-3/4 animate-pulse rounded bg-gray-100' />
        </div>;
}
export default PdpCtaSkeleton;